import React, { Fragment } from 'react';
import HighlightIcon from '../HighlightIcon';
import {
  CheckOutlined,
} from '@/components2/Icons';
export default function Vertical({
  highlights,
  facility,
  size = null,
  airportinitials,
  isCity,
  ...props
}) {
  const checkedHighlights = highlights.filter((highlight) => highlight.check);

  const getHighlight = (type) =>
    checkedHighlights.find((h) => h.type === type);

  const freeShuttle = getHighlight('facility_free_shuttles');
  const shuttleFrequency = getHighlight('facility_shuttle_frequency');
  const openHour = getHighlight('facility_open_hour');
  const accessibility = getHighlight('facility_accessibility');
  const freeCancellation = getHighlight('facility_free_cancellation');
  const notes = getHighlight('facility_additional_comments');
  const evCharger = getHighlight('facility_eletric_car');

  return (
    <>
      <div
        className="flex flex-col justify-start items-start"
        {...props}
      >
        {isCity ?
          <>
            {openHour && (
              <div className="flex flex-row flex-nowrap items-center">
                <div className="shrink-0">
                  <HighlightIcon
                    type="open_hour"
                    width={16}
                    height={16}
                    stroke="#434343"
                  />
                </div>
                <p className="text-sm text-center font-bold whitespace-nowrap ml-2 mr-1">
                  Facility Access
                </p>
                <p className="font-bold text-sm line-clamp-1">
                  {openHour.description}
                </p>
              </div>
            )}
            {accessibility && (
              <div className="flex flex-row flex-nowrap items-center">
                <div className="shrink-0">
                  <HighlightIcon
                    type="accessible"
                    width={16}
                    height={16}
                    fill="#434343"
                  />
                </div>
                <p className="text-sm text-center font-bold whitespace-nowrap ml-2 mr-1">
                  Wheelchair Accessible
                </p>
              </div>
            )}
            {evCharger && (
              <div className="flex flex-row flex-nowrap items-center">
                <div className="shrink-0">
                  <HighlightIcon
                    type="eletric_car"
                    width={16}
                    height={16}
                    fill="#434343"
                  />
                </div>
                <p className="text-sm text-center font-bold whitespace-nowrap ml-2 mr-1">
                  EV Charger
                </p>
              </div>
            )}
            {notes && (
              <div className="flex flex-row flex-nowrap items-center">
                <div className="shrink-0">
                  <HighlightIcon
                    type="additional_comments"
                    width={16}
                    height={16}
                    fill="#434343"
                  />
                </div>
                <p className="text-sm text-center font-bold whitespace-nowrap ml-2 mr-1">
                  Notes
                </p>
                <p className="font-bold text-sm line-clamp-1">
                  {notes.description}
                </p>
              </div>
            )}
            {freeCancellation && (
              <div className="flex flex-row flex-nowrap items-center">
                <div className="shrink-0">
                  <CheckOutlined className="text-green-600" />
                </div>
                <p className="text-sm text-center font-bold whitespace-nowrap text-green-600 ml-2 mr-1">
                  Free Cancellation
                </p>
              </div>
            )}
          </>
          :
          <>
            {freeShuttle && (
              <div className="flex flex-row flex-nowrap items-center gap-2">
                <div className="shrink-0">
                  <HighlightIcon
                    type="free-shuttle"
                    width={16}
                    height={16}
                    fill="#434343"
                  />
                </div>
                <p className="text-sm text-center font-bold whitespace-nowrap">
                  Free Shuttle
                </p>
                {shuttleFrequency?.description && (
                  <p className="text-center text-sm line-clamp-1">
                    {shuttleFrequency.description}
                  </p>
                )}
              </div>
            )}
            {checkedHighlights.map((highlight, index) => (
              <Fragment key={highlight.type + index}>
                {highlight.type === 'facility_no_shuttles' && (
                  <div className="flex flex-row items-center">
                    <HighlightIcon
                      type="no-free-shuttle"
                      width={16}
                      height={16}
                      fill="#434343"
                    />
                    <p className="text-sm mt-1 text-center font-bold mx-2 mb-1">
                      No Shuttle
                    </p>
                  </div>
                )}
                {airportinitials && (highlight.type === 'facility_distance') && (
                  <div className="flex flex-row items-center">
                    <HighlightIcon
                      type="distance"
                      width={16}
                      height={16}
                      fill="#434343"
                    />

                    {highlight.description ? (
                      <p className="text-center text-sm mx-2 font-bold">
                        {highlight.description} to {airportinitials}
                      </p>
                    ) : (
                      <p className="text-center text-sm mx-2 font-bold">
                        {facility.facility_airport_distance}{' '}
                        {`${facility.facility_airport_distance === 1
                          ? 'mile'
                          : 'miles'
                          }`} to {airportinitials}
                      </p>
                    )}
                  </div>
                )}
                {highlight.type === 'facility_free_cancellation' && (
                  <div className="flex flex-row items-center">
                    <CheckOutlined className="text-green-600" />
                    <p className="text-center text-sm mx-2.5 font-bold text-green-600">
                      Free Cancellation
                    </p>
                  </div>
                )}
              </Fragment>
            ))}
          </>
        }
      </div>
    </>
  );
}
